import "./style.scss";
import { render } from "react-dom";
import { map } from "lodash";
import carousel from "./loader/carousel";
import icon from "./loader/icon";
import timeline from "./loader/timeline";

const components = {
  carousel,
  icon,
  timeline,
};

map(components, (jsx, jsElement) => {
  const nodes = document.querySelectorAll(`[data-cms-component=${jsElement}]`);
  [].forEach.call(nodes, (node) => {
    if (!node) {
      return;
    }
    const state = JSON.parse(node.dataset.cmsState);
    render(jsx(state), node);
  });
});
